var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainLayout',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"box"},[_c('TableServiceType')],1),_c('hr')])])}
var staticRenderFns = []

export { render, staticRenderFns }